/* eslint-disable import/prefer-default-export */

export function isReactText(children: React.ReactNode) {
  return ["string", "number"].includes(typeof children);
}
